import React from "react"
import { MDXProvider } from "@mdx-js/react"
import { graphql, Link, PageProps } from "gatsby"
import Layout from "../components/layout"
import Img from "gatsby-image"
import { ArrowLeft } from "react-feather"
import { MDXRenderer } from "gatsby-plugin-mdx"

import { Row, Col } from "../components/shortcodes/index"

import { BlogQuery } from "./__generated__/BlogQuery"

export default function blog({ location, data }: PageProps<BlogQuery, {}>) {
    return (
        <Layout
            seo={{
                title: data.mdx.frontmatter.title,
                description: data.mdx.frontmatter.description,
                image: data.mdx.frontmatter.banner.publicURL,
            }}
            navPlaceholder={false}
            front={true}
            location={location}
        >
            <article>
                <header className="article-hero">
                    <Img
                        fluid={
                            data.mdx.frontmatter.banner.childImageSharp.fluid
                        }
                        alt={data.mdx.frontmatter.title}
                        style={{ height: "100%" }}
                        imgStyle={{ objectFit: "cover" }}
                    />
                    <div className="article-scrim"></div>

                    <div className="absolute bottom-0 left-0 w-full pb-12 lg:pb-20">
                        <div className="large-container">
                            <div className="measure">
                                <p
                                    className="eyebrow"
                                    style={{ color: "#DCC79A" }}
                                >
                                    {data.mdx.frontmatter.date}
                                </p>
                                <h1
                                    className="display-2 mt-5"
                                    style={{ color: "#FBF9F5" }}
                                >
                                    {data.mdx.frontmatter.title}
                                </h1>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="large-container">
                    <div className="measure">
                        {data.mdx.frontmatter.description && (
                            <p className="lede pt-16 lg:pt-24 pb-4">
                                {data.mdx.frontmatter.description}
                            </p>
                        )}
                        <div className="rule my-10"></div>

                        <div className="post-content pb-16">
                            <MDXProvider components={{ Row, Col }}>
                                <MDXRenderer>{data.mdx.body}</MDXRenderer>
                            </MDXProvider>
                        </div>

                        <div className="rule mb-10"></div>
                        <div className="pb-24 lg:pb-32">
                            <Link to="/blog" className="link-quiet">
                                <ArrowLeft
                                    size={15}
                                    strokeWidth={1.5}
                                    className="mr-3"
                                />
                                Wróć do bloga
                            </Link>
                        </div>
                    </div>
                </div>
            </article>
        </Layout>
    )
}

export const query = graphql`
    query BlogQuery($slug: String!) {
        mdx(fields: { slug: { eq: $slug } }) {
            body
            frontmatter {
                title
                date(formatString: "DD MMMM YYYY")
                description
                banner {
                    publicURL
                    childImageSharp {
                        fluid(maxWidth: 1920) {
                            srcSet
                            ...GatsbyImageSharpFluid
                        }
                        id
                    }
                }
            }
        }
    }
`
